import { Injectable } from '@angular/core';
import { ContextService } from 'src/app/services/context/context.service';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  constructor(private context: ContextService) { }

  get token() {
    return this.context.token;
  }
}
